import type { RouteType } from 'common/types/route';
import { preloadLazyComponent } from 'common/utils/useLoading';

export const routes: RouteType[] = [
    {
        component: preloadLazyComponent(() => import('module/activestudysite/ActiveStudySitePage')),
        permissions: [
            'StudyInstanceAppointment_Create',
            'Patient_Create',
            'Patient_Read',
            'StudyInstanceAppointment_Read',
            'StudyInstanceAppointment_Edit',
            'Patient_Edit',
        ],
        path: '/activestudysite',
        role: null,
    },
];
